
if (window.matchMedia("(max-width: 768px)").matches) {
let footerBlockH2s = document.querySelectorAll('footer .footer__block--menu h2');
footerBlockH2s.forEach(h2 => {
    h2.addEventListener('click', (e) => {
        let nextDiv = e.target.nextElementSibling;
        e.currentTarget.parentNode.classList.add('active')
        let divs = document.querySelectorAll('footer .footer__quicklinks');
        if(divs.length > 0) {
            divs.forEach(div => {
                if(div !== nextDiv) {
                    div.parentNode.classList.remove('active')
                }
            });
        }
    });
});
}

var selector = document.querySelectorAll(".selector-language");

selector.forEach(element => {
  element.addEventListener("change", function () {
        var selectedLanguage = this.value;
        var currentUrl = window.location.href;
        var defaultLanguage = element[0].value;
        var baseUrl = currentUrl.split("/")[0] + "//" + currentUrl.split("/")[2];
        var path = currentUrl.substring(baseUrl.length);
        var hasLanguagePath = path.match(/^\/[a-z]{2}\//);
        if (selectedLanguage !== defaultLanguage) {
            if (!hasLanguagePath) {
                window.location.href = baseUrl + '/' + selectedLanguage + path;
            } else {
                window.location.href = baseUrl + '/' + selectedLanguage + path.substring(3);
            }
        } else {
            if (hasLanguagePath) {
                window.location.href = baseUrl + path.substring(3);
            }
        }
    });
});

//modal Geolocation
 // Get the modal
 var modal = document.getElementById("modal_geolocation");
 // Get the <span> element that closes the modal
 var span = document.getElementsByClassName("geolocation_close")[0];
 // When the user clicks on the button, open the modal
 openModalGeolocation = function () {
   modal.style.display = "block";
 }
 // When the user clicks on <span> (x), close the modal
 span.onclick = function () {
   modal.style.display = "none";
 }
 // When the user clicks anywhere outside of the modal, close it
 window.onclick = function (event) {
   if (event.target == modal) {
     modal.style.display = "none";
   }
 }

 // add event function to close select on click
function closeSelect(){
    document.querySelector('#details_contact-form').removeAttribute('open');
}

const inputCountries = document.querySelectorAll('.redirect-stores-SP');
const confirmButton = document.getElementById('confirmButton');
let selectedCountry = null;

inputCountries.forEach(countryElement => {
  countryElement.addEventListener('click', e => {
    selectedCountry = e.target.value;
  });
});

confirmButton.addEventListener('click', e => {
  e.preventDefault();

  if (selectedCountry) {
    switch (selectedCountry) {
        case 'France':
          window.location.href = "https://fr.simone-perele.com/";
          break;
        case 'Australia':
          window.location.href = "https://www.simone-perele.com.au/";
          break;
        case 'Belgium':
          window.location.href = "https://be.simone-perele.com/";
          break;
        case 'Luxembourg':
          window.location.href = "https://be.simone-perele.com/";
          break;
        case 'Netherlands':
          window.location.href = "https://be.simone-perele.com/nl";
          break;
        case 'Slovakia':
          window.location.href = "https://www.simoneperele.sk/";
          break;
        case 'Czechia':
          window.location.href = "https://www.simoneperele.cz/";
          break;
        case 'NewZealand':
          window.location.href = "https://www.simone-perele.com/en-int/";
          break;
        case 'UnitedKingdom':
          window.location.href = "https://uk.simone-perele.com/";
          break;
        case 'UnitedStates':
          window.location.href = "https://us.simone-perele.com/";
          break;         
        default:
          break;
      }
    }
    });
  

